import React from 'react';
import { Info } from 'lucide-react';

/**
 * A partner's trial of Powston's API has ended on this site (backend #2236).
 *
 * Powston no longer controls the site, so the setup prompts elsewhere on the
 * page ("No primary inverter set", failing readiness checks) read like a fault
 * Powston should fix. They are not: the owner's installer advises on the setup
 * going forward. The wording is the backend's (`api_trial_ended_notice.message`)
 * so the dashboard, problem reports and the assistant say the same thing; it
 * is deliberately generic and never names the partner or the commercial reason.
 *
 * Renders nothing unless the backend published the notice.
 */
export type ApiTrialEndedNoticeData = { state: 'api_trial_ended'; message: string };

const ApiTrialEndedNotice: React.FC<{
  notice?: ApiTrialEndedNoticeData | null;
  className?: string;
}> = ({ notice, className = '' }) => {
  if (!notice?.message) return null;
  return (
    <div
      role="status"
      className={`rounded-xl border border-amber-300 dark:border-amber-700 bg-amber-50 dark:bg-amber-900/20 p-5 ${className}`}
    >
      <div className="flex items-start gap-3">
        <Info className="mt-0.5 h-5 w-5 shrink-0 text-amber-600 dark:text-amber-400" aria-hidden="true" />
        <div>
          <h3 className="text-base font-semibold text-amber-900 dark:text-amber-300 mb-1">
            Trial finished
          </h3>
          <p className="text-sm text-amber-800 dark:text-amber-400 leading-relaxed">{notice.message}</p>
        </div>
      </div>
    </div>
  );
};

export default ApiTrialEndedNotice;
